<div class="container" [dir]="locale.lang === 'en' ? 'ltr' : 'rtl'">
	<div class="d-flex align-items-center py-2">
		<h2 class="pt-2 m-0" style="flex: 1">{{ locale.translations['ads']['qrcode']['n410'] }}</h2>
		<button mat-icon-button [ngClass]="{ closeLTR: locale.lang === 'en', closeRTL: locale.lang !== 'en' }" (click)="onClose()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-divider></mat-divider>

	<div class="py-4">
		<h4>{{ locale.translations['ads']['qrcode']['n441'] }}</h4>
		<div class="d-flex">
			<div class="social-cont ml-0 mr-0" [url]="data.url" shareButton="facebook"><img [src]="'assets/images/social/Facebook.svg' | s3Image" alt="Facebook" /></div>
			<div class="social-cont" [url]="data.url" shareButton="whatsapp"><img [src]="'assets/images/social/whatsapp.svg' | s3Image" alt="Whatsapp" /></div>
			<div class="social-cont" (click)="share(instagram)"><img [src]="'assets/images/social/instagram.svg' | s3Image" alt="Instagram" /></div>
			<div class="social-cont mr-0" (click)="share(gmailUrl)"><img [src]="'assets/images/social/Gmail.svg' | s3Image" alt="Gmail" /></div>
		</div>
	</div>

	<div class="pt-4"></div>
</div>
